<template>
    <div class="idle-resource-device-pane">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="page.pageTotal"
            :loading="loading"
            :currentPage="page.pageNo"
            searchId="idleResourceDeviceSearchId"
            :pageID="config.table.pageId"
            @selectChange="selectChange"
            @on-reset="handleReset"
            @edit-btn="handleEdit"
            @sensitiveClick="handleSensitiveClick"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
            <div slot="provinceCodeSlot">
                <el-select v-model="slotSearchObj.provinceCode" placeholder="省份" clearable @change="handleProvinceChange">
                    <el-option
                        v-for="option in provinceOptions"
                        :key="option.label + '_' +option.value"
                        :label="option.label"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </div>
            <div slot="provinceCodeAdvanceSlot">
                <el-select class="region-select" v-model="slotSearchObj.provinceCode" placeholder="省份" clearable @change="handleProvinceChange">
                    <el-option
                        v-for="option in provinceOptions"
                        :key="option.label + '_' +option.value"
                        :label="option.label"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </div>
            <div slot="cityCodeListSlot">
                <el-select v-model="slotSearchObj.cityCodeList" placeholder="城市" clearable multiple collapse-tags @change="handleCityChange">
                    <el-option
                        v-for="option in cityOptions"
                        :key="option.label + '_' +option.value"
                        :label="option.label"
                        :value="option.value"
                        multiple
                    ></el-option>
                </el-select>
            </div>
            <div slot="cityCodeListAdvanceSlot">
                <el-select class="region-select" v-model="slotSearchObj.cityCodeList" placeholder="城市" clearable multiple collapse-tags @change="handleCityChange">
                    <el-option
                        v-for="option in cityOptions"
                        :key="option.label + '_' +option.value"
                        :label="option.label"
                        :value="option.value"
                        multiple
                    ></el-option>
                </el-select>
            </div>
            <div slot="table-module-btn">
                <el-tooltip effect="dark" content="新增" placement="bottom">
                    <el-button class="bigData-btn-add" icon="el-icon-plus" type="primary" size="mini" @click="handleAdd"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="导入" placement="bottom">
                    <el-button class="bigData-btn-upload" icon="el-icon-upload2" size="mini" @click="handleImport"></el-button>
                </el-tooltip>
                <reportExport #default="{ submit }" :reportCode="reportCode">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <el-button
                            icon="el-icon-download"
                            size="mini"
                            :loading="exportLoading"
                            @click="handleExport(submit)"
                        ></el-button>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <el-button class="bigData-btn-del" type="primary" :loading="delLoading" @click="handleDel">删除</el-button>
                <el-button class="bigData-btn-stop" type="primary" :loading="stopLoading" @click="handleStop">停用</el-button>
            </div>
        </m-pane>
        <DeviceOperateDialog
            ref="odRef"
            :provinceOptions="provinceOptions"
            @refresh="getTableData"
        />
        <ImportDialog
            ref="importRef"
            :tempName="tempName"
            :tempParams="tempParams"
            :tempApi="downloadTemplate"
            :importApi="importEquipmentIdle"
            @reload="getTableData"
        />
    </div>
</template>
<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs'
import bigDataLog from '@/utils/bigDataLog'
import mPane from '@/components/supplierPanel';
import reportExport from '@/components/lots/reportExportPlugin';
import DeviceOperateDialog from './DeviceOperateDialog.vue';
import ImportDialog from './ImportDialog.vue';
import config from './config.js';
import { searchEqIdleResources, deleteEqIdleResources, disableEqIdleResources, downloadTemplate, importEquipmentIdle } from '../../../api/storageSupManage/idleResource.js';
import { getProvinces, getCitys } from '../../../utils/getArea.js'
import { getSensitiveVal } from '../../../utils/common.js'


const INIT_SEARCH_OBJ = {
    createTimeStart: dayjs().subtract(180, 'd').format('YYYY-MM-DD 00:00:00'),
    createTimeEnd: dayjs().format('YYYY-MM-DD 23:59:59'),
}

export default {
    components: { mPane, reportExport, DeviceOperateDialog, ImportDialog },
    data() {
        return {
            loading: false,
            exportLoading: false,
            delLoading: false,
            stopLoading: false,
            isSensitive: true,
            totalData: [],
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            searchObj: JSON.parse(JSON.stringify(INIT_SEARCH_OBJ)),
            slotSearchObj: {
                provinceCode: '',
                cityCodeList: [],
            },
            provinceOptions: [],
            cityOptions: [],
            selected: [],
            tempName: '设备类发布资源导入.xlsx',
            downloadTemplate,
            importEquipmentIdle,
        };
    },
    computed: {
        ...mapState(['supplier']),
        config() {
            const configTemp = { ...config }
            configTemp.searchList = configTemp.lsrmDeviceSearchList
            configTemp.table = configTemp.lsrmDeviceTable
            if (!!this.supplier) {
                configTemp.searchList = configTemp.lspDeviceSearchList
                configTemp.table = configTemp.lspDeviceTable
            }
            return configTemp
        },
        reportCode() {
            return !this.supplier ? 'SRM_IDLE_DEVICE_LSRM_EXPORT' : 'SRM_IDLE_DEVICE_LSP_EXPORT'
        },
        tempParams() {
            let params = { fileName: 'supplierEquipmentIdleResources.xlsx' }
            if (this.supplier) {
                params = { fileName: 'supplierEquipmentIdleResourcesLSP.xlsx' }
            }
            return params
        },
    },
    methods: {
        selectChange(data) {
            this.selected = data;
        },
        getTableData() {
            this.loading = true
            searchEqIdleResources(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount;
                    this.totalData = res.data.list.map(item => {
                        item.contactNumber_ = (this.isSensitive && item.contactNumber) ?
                            getSensitiveVal(item.contactNumber, 'phone') : item.contactNumber
                        if (item.leavingFactoryTime) {
                            item.leavingFactoryTime = dayjs(item.leavingFactoryTime).format('YYYY-MM-DD')
                        }
                        return item
                    })
                }
            }).finally(() => { this.loading = false });
        },
        getParams() {
            const params = JSON.parse(JSON.stringify({ ...this.searchObj, ...this.slotSearchObj }));
            params.pageNo = this.page.pageNo
            params.pageSize = this.page.pageSize
            params.orderBy = 'create_time'
            params.orderByType = 'desc'
            if (params.createTimeArr && params.createTimeArr.length) {
                params.createTimeStart = dayjs(params.createTimeArr[0]).format('YYYY-MM-DD HH:mm:ss')
                params.createTimeEnd = dayjs(params.createTimeArr[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            if (!!this.supplier) {
                params.supplierCode = this.supplier.supplierCode
            }
            delete params.createTimeArr
            return params
        },
        searchChange(data) { // 点击查询
            this.page.pageNo = 1;
            this.searchObj = data;
            this.getTableData();
        },
        pageChange(pageNo) { // 切换分页页数
            this.isSensitive = true
            const phoneCol = config[this.supplier?'lspDeviceTable':'lsrmDeviceTable'].columns.findIndex(v => v.prop === 'contactNumber_')
            config[this.supplier?'lspDeviceTable':'lsrmDeviceTable'].columns[phoneCol].sensitiveValue = true
            this.page.pageNo = pageNo;
            this.getTableData();
        },
        sizeChange(pageSize) { // 切换分页显示条数
            this.isSensitive = true
            const phoneCol = config[this.supplier?'lspDeviceTable':'lsrmDeviceTable'].columns.findIndex(v => v.prop === 'contactNumber_')
            config[this.supplier?'lspDeviceTable':'lsrmDeviceTable'].columns[phoneCol].sensitiveValue = true
            this.page.pageNo = 1;
            this.page.pageSize = pageSize;
            this.getTableData();
        },
        handleReset() {
            this.slotSearchObj = {
                provinceCode: '',
                cityCodeList: [],
            }
        },
        handleImport() {
            this.$refs.importRef && this.$refs.importRef.open()
        },
        handleExport(submit) {
            const params = this.getParams()
            delete params.pageNo
            delete params.pageSize
            submit(params);
            this.exportLoading = true
            setTimeout(() => {
                this.exportLoading = false
            }, 2000)
        },
        handleAdd() {
            this.$refs.odRef.open()
        },
        handleEdit(row) {
            this.$refs.odRef.open(row)
            try { bigDataLog.sendDetailMessageByNames('仓储供应商管理,资源匹配,闲置资源,编辑'); } catch (e) { }
        },
        handleDel() {
            if (!this.selected.length) {
                return this.$message.warning('请选择数据进行删除!')
            }
            this.$confirm('您确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const ids = this.selected.map(item => item.id)
                this.delLoading = true
                deleteEqIdleResources(ids).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功!')
                        this.getTableData()
                    }
                }).finally(() => { this.delLoading = false })
            }).catch(() => { });
        },
        handleStop() {
            if (!this.selected.length) {
                return this.$message.warning('请选择数据进行停用!')
            }
            this.$confirm('您确定要停用吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const ids = this.selected.map(item => item.id)
                this.stopLoading = true
                disableEqIdleResources(ids).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('停用成功!')
                        this.getTableData()
                    }
                }).finally(() => { this.stopLoading = false })
            }).catch(() => { });
        },
        handleProvinceChange(val) {
            this.slotSearchObj.cityCodeList = []
            if (val) {
                this.setCityOptions(val)
            } else {
                this.cityOptions = []
            }
        },
        handleCityChange(val) {
            // this.searchObj.cityCode = val
        },
        setProvinceOptions() {
            getProvinces('100000').then(res => {
                this.provinceOptions = res;
            });
        },
        setCityOptions(provinceCode) {
            getCitys(provinceCode).then(res => {
                this.cityOptions = res;
            });
        },
        // 脱敏处理
        handleSensitiveClick(prop, val) {
            this.isSensitive = !this.isSensitive
            this.totalData.forEach(item => {
                item.contactNumber_ = (this.isSensitive && item.contactNumber) ?
                    getSensitiveVal(item.contactNumber, 'phone') : item.contactNumber
            })
        }
    },
    mounted() {
        this.setProvinceOptions()
        this.getTableData();
    },
    beforeDestroy() {
        // 脱敏重置
        this.isSensitive = true
        config.lsrmDeviceTable.columns.forEach(col => {
            if (col.sensitive) {
                col.sensitiveValue = true
            }
        })
        config.lspDeviceTable.columns.forEach(col => {
            if (col.sensitive) {
                col.sensitiveValue = true
            }
        })
    }
};
</script>
<style lang="less" scoped>
.region-select {
    width: 100%;
}
</style>
